import { action, makeObservable, observable } from "mobx";
import SwayyCarrierAPI from "../api/SwayyCarrierAPI";
import { SwayyCarrier } from "../../../models/SwayyCarrier/SwayyCarrier";

export class SwayyCarrierStore {
  swayyCarrierAPI: SwayyCarrierAPI;
  carriers: SwayyCarrier[];
  loading: boolean;
  error: string | null;

  constructor() {
    this.swayyCarrierAPI = new SwayyCarrierAPI();
    this.carriers = [];
    this.loading = false;
    this.error = null;

    makeObservable(this, {
      carriers: observable,
      loading: observable,
      error: observable,
      getCarriers: action,
      reset: action,
    });
  }

  getCarriers = async () => {
    this.loading = true;
    this.error = null;
    try {
      const carriers = await this.swayyCarrierAPI.getCarriers();
      this.carriers = carriers;
      return carriers;
    } catch (error: any) {
      this.error = error?.message || "Failed to fetch carriers";
      throw error;
    } finally {
      this.loading = false;
    }
  };

  reset = () => {
    this.carriers = [];
    this.loading = false;
    this.error = null;
  };
}

export const swayyCarrierStore = new SwayyCarrierStore();
